import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutCTA() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-20 lg:py-28 bg-slate-900">
      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      >
        <span className="inline-block px-3 py-1 bg-amber-500/20 border border-amber-400/30 text-amber-400 text-sm font-semibold uppercase tracking-widest rounded-full mb-6">
          Work With Us
        </span>
        <h2 className="text-4xl sm:text-5xl font-semibold text-white leading-tight mb-6">
          Ready to move forward with confidence?
        </h2>
        <p className="text-xl text-white/70 leading-relaxed mb-10">
          Whether you're looking to acquire a license, outsource compliance, or structure your business&nbsp; our team is ready to help.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/#contact"
            className="px-8 py-4 bg-amber-500 text-white text-lg font-semibold rounded-lg hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Book a Free Consultation
          </a>
          <Link
            to="/services"
            className="px-8 py-4 bg-white/10 text-white text-lg font-semibold rounded-lg hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer border border-white/20"
          >
            Explore Our Services
          </Link>
        </div>
      </div>
    </section>
  );
}
